<template>
  <div class="visual-identity">
    <!-- Hero Banner -->
    <HeroBanner
        :background-image="bannerImage"
        title="비주얼 아이덴티티"
        sub-title="전문성을 바탕으로 한 최고의 보청기전문기업, <br>다비치 히어링 보청기입니다."
    />

    <!-- Main Content -->
    <div class="identity-content">
      <!-- Word Mark Section -->
      <section class="identity-section wordmark-section">
        <h2 class="section-title">Word Mark<br>워드마크</h2>
        <p class="section-description">
          다비치는 세상을 맑고 밝게 비춘다는 순 우리말로 소외된 어려운 이웃까지 맑고 밝게 다 비춘다는 의미입니다. <br>
          워드마크는 다비치 브랜드의 아이덴티티와 핵심가치를 함축적으로 담고 있습니다. <br>
          다비치와 고객이 신뢰로 함께 만들어온 전통과 새롭게 펼쳐질 미래를 밝게 비추어 가는 아름다운 빛을 시각적으로 표현하였습니다.
        </p>

        <div class="wordmark-container">
          <div class="wordmark-item">
            <img :src="wordmarkEn" alt="DAVICH 워드마크 영문" class="wordmark-image-en" />
            <p class="wordmark-label">워드마크 (영문)</p>
          </div>

          <div class="wordmark-item">
            <img :src="wordmarkKo" alt="다비치 워드마크 국문" class="wordmark-image-ko" />
            <p class="wordmark-label">워드마크 (국문)</p>
          </div>
        </div>
      </section>

      <!-- Brand Slogan Section -->
      <section class="identity-section slogan-section">
        <h2 class="section-title">Brand Slogan<br>슬로건</h2>
        <p class="section-description">
          고객의 가치있는 미래를 열어가는 다비치의 브랜드 미션을 기준으로 신뢰, 조율, 공감의 브랜드 핵심가치가 새로운 다 비치 브랜드를 구체화 할 수 있도록 구성되어 있으며, Light Up Your Life 이라는 슬로건을 중심으로 다비치가 나아가야 할 방향을 설정하였습니다.
        </p>

        <div class="slogan-container">
          <img :src="slogan" alt="Light Up Your Life" class="slogan-image" />
        </div>
      </section>

      <!-- Signature Section -->
      <section class="identity-section signature-section">
        <h2 class="section-title">Signature<br>시그니처</h2>

        <div class="signature-content">
          <!-- Symbol Motif -->
          <div class="signature-item">
            <h3 class="signature-subtitle">Symbol motif</h3>
            <p class="signature-description">
              빛이 어둠에 은은하게 비추어 들어와 표면에 맺혀 부드럽 고 따스하게 스며들어가는 형상을 바탕으로 신뢰하고 공감 하고 조율하는 다비치다움을 모던하고 심플하게 해석하여 시각적으로 표현했습니다.
            </p>
            <div class="signature-image-container motif">
              <img :src="symbolMotif" :srcset="`${symbolMotif} 1x, ${symbolMotif2x} 2x`" alt="다비치 심볼 모티프" class="signature-image-motif" />
            </div>
          </div>

          <!-- Symbol Mark -->
          <div class="signature-item">
            <h3 class="signature-subtitle">Symbol Mark</h3>
            <p class="signature-description">
              다비치의 심볼의 12가지 빛의 흐름은 고객과 사회를 향한 봉사정신과 고객을 위해 묵묵히 노력하는 발걸음, 그리고 고객에게 감동을 전달하고자 하는 다비치의 사명감을 나타냅니다. 다비치의 새로운 심볼은 "어둠을 뚫고 나가는 빛의 형상이 새롭고 조화로운 질서로 맺혀 하나가 되어가는 과정을 의미합니다."
            </p>
            <div class="signature-image-container symbol">
              <img :src="symbol" alt="다비치 심볼 마크" class="signature-image-symbol" />
            </div>
          </div>
        </div>
      </section>

      <!-- Signature Combinations Section -->
      <section class="identity-section signature-combinations-section">
        <div class="combinations-header">
          <h2 class="section-title">Signature<br>시그니처</h2>
          <p class="combinations-intro">
            다비치의 심볼마크와 워드마크 그리고 슬로건의 조합은 각 형태에 따라 비례를 조정한 것이므로 사용의 오류를 방지 하기 위해 모든 원고의 사용은 매뉴얼 데이터에 의한 확대, 축소, 복사가 되어야 합니다.
          </p>
        </div>

        <div class="combinations-container">
          <!-- Vertical Combination -->
          <div class="combination-item  center full-width">
            <p class="combination-label">시그니처 상하 조합</p>
            <div class="combination-image-container vertical">
              <img :src="signatureUpDown" alt="다비치 시그니처 상하 조합" class="combination-image" />
            </div>
          </div>

          <!-- Horizontal Combinations -->
          <div class="horizontal-combinations">
            <!-- Korean Versions -->
            <div class="combination-item">
              <p class="combination-label">시그니처 보청기 좌우조합(국문)</p>
              <div class="combination-image-container horizontal">
                <img :src="signatureHearingKo" alt="다비치 히어링 보청기" class="combination-image-horizontal" />
              </div>
            </div>

            <div class="combination-item">
              <p class="combination-label">시그니처 안경 좌우조합(국문)</p>
              <div class="combination-image-container horizontal">
                <img :src="signatureGlassesKo" alt="다비치 안경" class="combination-image-horizontal" />
              </div>
            </div>

            <div class="combination-item">
              <p class="combination-label">시그니처 렌즈 좌우조합(국문)</p>
              <div class="combination-image-container horizontal">
                <img :src="signatureLensKo" alt="다비치 렌즈" class="combination-image-horizontal" />
              </div>
            </div>

            <!-- English Versions -->
            <div class="combination-item">
              <p class="combination-label">시그니처 보청기 좌우조합(영문)</p>
              <div class="combination-image-container horizontal">
                <img :src="signatureHearingEn" alt="DAVICH Hearing Aids" class="combination-image-horizontal" />
              </div>
            </div>

            <div class="combination-item">
              <p class="combination-label">시그니처 안경 좌우조합(영문)</p>
              <div class="combination-image-container horizontal">
                <img :src="signatureGlassesEn" alt="DAVICH Optical" class="combination-image-horizontal" />
              </div>
            </div>

            <div class="combination-item">
              <p class="combination-label">시그니처 렌즈 좌우조합(영문)</p>
              <div class="combination-image-container horizontal">
                <img :src="signatureLensEn" alt="DAVICH Lens" class="combination-image-horizontal" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import bannerBg from '@/assets/images/heros/01-1-top-img.png';
import wordmarkEn from '@/assets/images/banners/04/wordmark-eg.svg';
import wordmarkKo from '@/assets/images/banners/04/wordmark-ko.svg';
import slogan from '@/assets/images/banners/04/slogan.png';
import symbolMotif from '@/assets/images/banners/04/davich-symbol-motif.png';
import symbolMotif2x from '@/assets/images/banners/04/davich-symbol-motif@2x.png';
import symbol from '@/assets/images/banners/04/symbol.png';
import signatureUpDown from '@/assets/images/banners/04/symbol-up-down.png';
import signatureHearingKo from '@/assets/images/banners/04/symbol-hearing-signature-ko.svg';
import signatureHearingEn from '@/assets/images/banners/04/symbol-hearing-signature-eg.svg';
import signatureGlassesKo from '@/assets/images/banners/04/symbol-glasses-signature-ko.svg';
import signatureGlassesEn from '@/assets/images/banners/04/symbol-glasses-signature-eg.svg';
import signatureLensKo from '@/assets/images/banners/04/symbol-lens-signature-ko.svg';
import signatureLensEn from '@/assets/images/banners/04/symbol-lens-signature-eg.svg';

export default {
  name: 'VisualIdentity',
  components: { HeroBanner },
  data() {
    return {
      bannerImage: [bannerBg],
      wordmarkEn,
      wordmarkKo,
      slogan,
      symbolMotif,
      symbolMotif2x,
      symbol,
      signatureUpDown,
      signatureHearingKo,
      signatureHearingEn,
      signatureGlassesKo,
      signatureGlassesEn,
      signatureLensKo,
      signatureLensEn
    };
  }
};
</script>

<style scoped lang="scss">
.visual-identity {
  width: 100%;
  background: #FFFFFF;

  .identity-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    gap: 66.96px;
    padding: 0 0 80px;

    // Common Section Styles
    .identity-section {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .section-title {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 700;
        font-size: 32px;
        line-height: 48px;
        text-align: center;
        color: #222222;
        margin: 0 0 44.64px;
        width: 100%;
      }

      .section-description {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 400;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: -0.6px;
        color: #222222;
        margin: 0 0 44px;
        width: 426px;
        max-width: 90%;
      }
    }

    // Word Mark Section
    .wordmark-section {
      margin-top: 66px ;
      padding: 0;

      .wordmark-container {
        display: flex;
        flex-direction: column;
        gap: 50px;
        width: 100%;
        padding: 11.16px 0 0;

        .wordmark-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 11.16px;
          width: 100%;

          .wordmark-image-en {
            width: 245.54px;
            height: auto;
          }

          .wordmark-image-ko {
            width: 171.88px;
            height: auto;
          }

          .wordmark-label {
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 350;
            font-size: 18px;
            line-height: 30px;
            letter-spacing: -0.04em;
            text-align: center;
            color: #222222;
            margin: 0;
          }
        }
      }
    }

    // Brand Slogan Section
    .slogan-section {
      padding: 145.089px 0 0;
      width: 425px;
      max-width: 90%;

      .slogan-container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 33.48px 0 0;
        width: 100%;

        .slogan-image {
          width: 362.72px;
          max-width: 100%;
          height: auto;
        }
      }
    }

    // Signature Section
    .signature-section {
      padding: 145.089px 0 0;
      width: 425px;
      max-width: 90%;

      .section-title {
        font-family: 'Public Sans', sans-serif;
        margin-bottom: 50px;
      }

      .signature-content {
        display: flex;
        flex-direction: column;
        gap: 50px;
        width: 100%;

        .signature-item {
          display: flex;
          flex-direction: column;
          gap: 21.76px;
          width: 100%;

          .signature-subtitle {
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 700;
            font-size: 24px;
            line-height: 40px;
            letter-spacing: -0.5px;
            color: #222222;
            margin: 0;
          }

          .signature-description {
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 350;
            font-size: 18px;
            line-height: 30px;
            letter-spacing: -0.04em;
            color: #222222;
            margin: 0;
          }

          .signature-image-container {
            display: flex;
            justify-content: center;
            align-items: center;

            &.motif {
              padding: 12.28px 0 23.44px;

              .signature-image-motif {
                width: 100%;
                max-width: 425px;
                height: auto;
              }
            }

            &.symbol {
              padding: 23.44px 0 0;

              .signature-image-symbol {
                width: 238.84px;
                height: auto;
              }
            }
          }
        }
      }
    }

    // Signature Combinations Section
    .signature-combinations-section {
      padding: 145.089px 0 0;
      width: 425px;
      max-width: 90%;
      gap: 64px;

      .combinations-header {
        width: 100%;
        margin-bottom: 44.08px;

        .section-title {
          font-family: 'Public Sans', sans-serif;
          margin-bottom: 44.08px;
        }

        .combinations-intro {
          font-family: 'Noto Sans KR', sans-serif;
          font-weight: 350;
          font-size: 17.86px;
          line-height: 28px;
          color: #222222;
          margin: 0;
          width: 419px;
          max-width: 100%;
        }
      }

      .combinations-container {
        display: flex;
        flex-direction: column;
        gap: 33.48px;
        width: 100%;

        .combination-item {
          display: flex;
          flex-direction: column;
          gap: 0;
          width: 100%;
          align-items: start;

          &.full-width {
            .combination-image-container {
              padding: 0;
            }
          }

          .combination-label {
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 350;
            font-size: 18px;
            line-height: 30px;
            letter-spacing: -0.04em;
            color: #222222;
            margin: 0;
            margin-bottom: 15px;
            text-align: center;
          }

          .combination-image-container {
            display: flex;
            justify-content: center;
            align-items: center;

            &.vertical {
              padding: 0;

              .combination-image {
                width: 167.41px;
                height: auto;
                margin: 20px;
              }
            }

            &.horizontal {
              //padding: 14.51px 0 23.44px;

              .combination-image-horizontal {
                width: 279.02px;
                max-width: 100%;
                height: auto;
              }
            }
          }
        }

        .combination-item.center{
          align-items: center;
        }

        .horizontal-combinations {
          display: flex;
          flex-direction: column;
          gap: 66.96px;
          padding: 66.96px 0 0;
          width: 100%;
        }
      }
    }
  }

  // Responsive Design
  @media (max-width: 768px) {
    .identity-content {
      gap: 50px;
      padding: 0 0 60px;

      .identity-section {
        .section-title {
          font-size: 28px;
          line-height: 40px;
          margin-bottom: 36px;
        }

        .section-description {
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 36px;
        }
      }

      .wordmark-section {
        .wordmark-container {
          gap: 44px;

          .wordmark-item {
            .wordmark-image-en {
              width: 200px;
            }

            .wordmark-image-ko {
              width: 140px;
            }

            .wordmark-label {
              font-size: 16px;
              line-height: 26px;
            }
          }
        }
      }

      .slogan-section {
        padding: 100px 0 0;

        .slogan-container {
          padding: 28px 0 0;

          .slogan-image {
            width: 300px;
          }
        }
      }

      .signature-section {
        padding: 100px 0 0;

        .section-title {
          margin-bottom: 44px;
        }

        .signature-content {
          gap: 44px;

          .signature-item {
            gap: 18px;

            .signature-subtitle {
              font-size: 20px;
              line-height: 34px;
            }

            .signature-description {
              font-size: 16px;
              line-height: 26px;
            }

            .signature-image-container {
              &.symbol {
                .signature-image-symbol {
                  width: 180px;
                }
              }
            }
          }
        }
      }

      .signature-combinations-section {
        padding: 100px 0 0;
        gap: 60px;

        .combinations-header {
          margin-bottom: 36px;

          .section-title {
            margin-bottom: 36px;
          }

          .combinations-intro {
            font-size: 15px;
            line-height: 24px;
          }
        }

        .combinations-container {
          gap: 28px;

          .combination-item {
            .combination-label {
              font-size: 16px;
              line-height: 26px;
            }

            .combination-image-container {
              &.vertical {
                .combination-image {
                  width: 130px;
                }
              }

              &.horizontal {
                padding: 12px 0 20px;

                .combination-image-horizontal {
                  width: 220px;
                }
              }
            }
          }

          .horizontal-combinations {
            gap: 50px;
            padding: 50px 0 0;
          }
        }
      }
    }
  }

  @media (max-width: 450px) {
    .identity-content {
      gap: 40px;
      padding: 0 0 50px;

      .identity-section {
        .section-title {
          font-size: 24px;
          line-height: 36px;
          margin-bottom: 28px;
        }

        .section-description {
          font-size: 15px;
          line-height: 24px;
          margin-bottom: 28px;
        }
      }

      .wordmark-section {
        .wordmark-container {
          gap: 36px;

          .wordmark-item {
            .wordmark-image-en {
              width: 160px;
            }

            .wordmark-image-ko {
              width: 110px;
            }

            .wordmark-label {
              font-size: 15px;
              line-height: 24px;
            }
          }
        }
      }

      .slogan-section {
        padding: 80px 0 0;

        .slogan-container {
          padding: 24px 0 0;

          .slogan-image {
            width: 250px;
          }
        }
      }

      .signature-section {
        padding: 80px 0 0;

        .section-title {
          margin-bottom: 36px;
        }

        .signature-content {
          gap: 36px;

          .signature-item {
            gap: 16px;

            .signature-subtitle {
              font-size: 18px;
              line-height: 30px;
            }

            .signature-description {
              font-size: 15px;
              line-height: 24px;
            }

            .signature-image-container {
              &.symbol {
                .signature-image-symbol {
                  width: 150px;
                }
              }
            }
          }
        }
      }

      .signature-combinations-section {
        padding: 80px 0 0;
        gap: 50px;

        .combinations-header {
          margin-bottom: 30px;

          .section-title {
            margin-bottom: 30px;
          }

          .combinations-intro {
            font-size: 14px;
            line-height: 22px;
          }
        }

        .combinations-container {
          gap: 24px;

          .combination-item {
            .combination-label {
              font-size: 15px;
              line-height: 24px;
            }

            .combination-image-container {
              &.vertical {
                .combination-image {
                  width: 110px;
                }
              }

              &.horizontal {
                padding: 10px 0 18px;

                .combination-image-horizontal {
                  width: 180px;
                }
              }
            }
          }

          .horizontal-combinations {
            gap: 40px;
            padding: 40px 0 0;
          }
        }
      }
    }
  }
}
</style>